import type { PathType } from './types';
import { getPath } from './types';

export const masterDataPaths: { [key: string]: PathType } = {
  employee: getPath('/system-admin/employee', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee'
  ]),
  employeeAdd: getPath('/system-admin/employee/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'action.add'
  ]),
  employeeQR: getPath('/system-admin/employee/qr', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'action.getQR'
  ]),
  employeeEdit: getPath('/system-admin/employee/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'action.edit'
  ]),
  employeeDetail: getPath('/system-admin/employee/detail', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'page.detail'
  ]),
  seasonalEmployee: getPath('/system-admin/seasonal-employee', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.seasonalEmployee'
  ]),
  seasonalEmployeeAdd: getPath('/system-admin/seasonal-employee/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.seasonalEmployee',
    'action.add'
  ]),
  seasonalEmployeeQR: getPath('/system-admin/seasonal-employee/qr', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.seasonalEmployee',
    'action.getQR'
  ]),
  seasonalEmployeeEdit: getPath('/system-admin/seasonal-employee/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.seasonalEmployee',
    'action.edit'
  ]),
  seasonalEmployeeDetail: getPath('/system-admin/seasonal-employee/detail', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.seasonalEmployee',
    'page.detail'
  ]),
  department: getPath('/system-admin/department', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.department'
  ]),
  branch: getPath('/system-admin/branch', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.branch'
  ]),
  position: getPath('/system-admin/position', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.position'
  ]),
  board: getPath('/system-admin/board', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.board']),
  level: getPath('/system-admin/level', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.level']),
  tier: getPath('/system-admin/tier', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.tier']),
  jobCategory: getPath('/system-admin/job-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobCategory'
  ]),
  jobCategoryAdd: getPath('/system-admin/job-category/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobCategory',
    'action.add'
  ]),
  jobCategoryEdit: getPath('/system-admin/job-category/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobCategory',
    'action.edit'
  ]),
  organizationChart: getPath('/system-admin/organization-chart', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.organizationChart'
  ]),
  organizationChartAdd: getPath('/system-admin/organization-chart/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.organizationChart',
    'action.add'
  ]),
  organizationChartEdit: getPath('/system-admin/organization-chart/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.organizationChart',
    'action.edit'
  ]),
  job: getPath('/system-admin/job', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.job']),
  duty: getPath('/system-admin/duty', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.duty']),
  jobDescription: getPath('/system-admin/job-description', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobDescription'
  ]),
  asset: getPath('/system-admin/asset', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.asset']),
  assetType: getPath('/system-admin/asset-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.assetType'
  ]),
  assetGroup: getPath('/system-admin/asset-group', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.assetGroup'
  ]),
  degreeType: getPath('/system-admin/degree-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.degreeType'
  ]),
  degree: getPath('/system-admin/degree', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.degree'
  ]),
  partnerType: getPath('/system-admin/partner-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partnerType'
  ]),
  partner: getPath('/system-admin/partner', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partner'
  ]),
  partnerAdd: getPath('/system-admin/partner/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partner',
    'action.add'
  ]),
  partnerEdit: getPath('/system-admin/partner/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partner',
    'action.edit'
  ]),
  accountingAccountType: getPath('/system-admin/accounting-account-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.accountingAccountType'
  ]),
  generalAccountingAccount: getPath('/system-admin/general-accounting-account', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.generalAccountingAccount'
  ]),
  employeeContract: getPath('/system-admin/employee-contract', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employeeContract'
  ]),
  contractType: getPath('/system-admin/contract-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.contractType'
  ]),
  contractTemplate: getPath('/system-admin/contract-template', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.contractTemplate'
  ]),
  applicationInfo: getPath('/system-admin/application-info', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo'
  ]),
  applicationInfoAdd: getPath('/system-admin/application-info/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo',
    'action.add'
  ]),
  applicationInfoEdit: getPath('/system-admin/application-info/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo',
    'action.edit'
  ]),
  applicationInfoDetail: getPath('/system-admin/application-info/detail', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo',
    'page.detail'
  ]),
  certificate: getPath('/system-admin/certificate', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.certificate'
  ]),
  errorCode: getPath('/system-admin/error-code', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.errorCode'
  ]),
  hrTicketCategory: getPath('/system-admin/hr-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.hrTicketCategory'
  ]),
  resource: getPath('/system-admin/resource', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.resource'
  ]),
  role: getPath('/system-admin/role', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.role']),
  roleAdd: getPath('/system-admin/role/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.role',
    'action.add'
  ]),
  roleEdit: getPath('/system-admin/role/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.role',
    'action.edit'
  ]),
  userResource: getPath('/system-admin/user-resource', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userResource'
  ]),
  userResourceAdd: getPath('/system-admin/user-resource/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userResource',
    'action.add'
  ]),
  userResourceEdit: getPath('/system-admin/user-resource/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userResource',
    'action.edit'
  ]),
  permission: getPath('/system-admin/permission', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.permission'
  ]),
  distance: getPath('/system-admin/distance', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.distance'
  ]),
  holiday: getPath('/system-admin/holiday', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.holiday'
  ]),
  sundayCompensatory: getPath('/system-admin/sunday-compensatory', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.sundayCompensatory'
  ]),
  fuelConsumption: getPath('/system-admin/fuel-consumption', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.fuelConsumption'
  ]),
  fuelUnitPrice: getPath('/system-admin/fuel-unit-price', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.fuelUnitPrice'
  ]),
  vehicleType: getPath('/system-admin/vehicle-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.vehicleType'
  ]),
  subSystem: getPath('/system-admin/sub-system', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.subSystem'
  ]),
  subSystemAdd: getPath('/system-admin/sub-system/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.subSystem',
    'action.add'
  ]),
  subSystemEdit: getPath('/system-admin/sub-system/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.subSystem',
    'action.edit'
  ]),
  workDescription: getPath('/system-admin/work-description', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.workDescription'
  ]),
  userTicketCategory: getPath('/system-admin/user-ticket-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userTicketCategory'
  ]),
  userJobCategory: getPath('/system-admin/user-job-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userJobCategory'
  ]),
  shift: getPath('/system-admin/shift', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.shift']),
  managerAssignment: getPath('/system-admin/manager-assignment', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.managerAssignment'
  ]),
  mobileVersion: getPath('/system-admin/mobile-versions', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.mobileVersion'
  ]),
  productionUnit: getPath('/system-admin/production-unit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionUnit'
  ]),
  productionUnitAdd: getPath('/system-admin/production-unit/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionUnit',
    'action.add'
  ]),
  productionUnitEdit: getPath('/system-admin/production-unit/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionUnit',
    'action.edit'
  ]),
  proposalType: getPath('/system-admin/proposal-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.proposalType'
  ]),
  acceptancePermission: getPath('/system-admin/acceptance-permission', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.acceptancePermission'
  ]),
  dataTable: getPath('/system-admin/data-table', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.dataTable'
  ]),
  dataTableAdd: getPath('/system-admin/data-table/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.dataTable',
    'action.add'
  ]),
  dataTableEdit: getPath('/system-admin/data-table/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.dataTable',
    'action.edit'
  ]),
  siteLocation: getPath('/system-admin/site-location', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.siteLocation'
  ]),
  cost: getPath('/system-admin/cost', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.cost']),
  businessProcessCatalog: getPath('/system-admin/business-process-catalog', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.businessProcessCatalog'
  ]),
  objType: getPath('/system-admin/obj-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.objType'
  ]),
  issueCategory: getPath('/system-admin/issue-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.issueCategory'
  ]),
  objGroup: getPath('/system-admin/obj-group', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.objGroup'
  ]),
  obj: getPath('/system-admin/object', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.obj']),
  issue: getPath('/system-admin/issue', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.issue']),
  issueCause: getPath('/system-admin/issue-cause', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.issueCause'
  ]),
  issueSolution: getPath('/system-admin/issue-solution', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.issueSolution'
  ]),
  user: getPath('/system-admin/user', ['v2.sidebar.home', 'sidebar.master-data.index', 'sidebar.master-data.user']),

  // Sử dụng bên sản xuất (PM)
  factory: getPath('/system-admin/factory', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.factory'
  ]),
  productionLine: getPath('/system-admin/production-line', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionLine'
  ]),
  productionLineAdd: getPath('/system-admin/production-line/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionLine',
    'action.add'
  ]),
  productionLineEdit: getPath('/system-admin/production-line/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionLine',
    'action.edit'
  ]),
  wareHouse: getPath('/system-admin/ware-house', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.wareHouse'
  ])
};
